// transfom.jsx
import React from "react";
import "../css/transfom.css";

export default function Transfom() {
  const phoneDisplay = "72378 98275";
  const telHref = "tel:7237898275";

  return (
    <section className="transfom-section" aria-labelledby="transfom-heading">
      <div className="transfom-inner container">
        <h2 id="transfom-heading" className="transfom-title">
          Transform Your Comfort with Our Services Today!
        </h2>

        <a
          className="transfom-phone"
          href={telHref}
          aria-label={`Call ${phoneDisplay}`}
        >
          {phoneDisplay}
        </a>
      </div>
    </section>
  );
}
